import React from 'react';
import { useDispatch } from 'react-redux';
// styles
import styles from './styles.module.scss';
// types
import { IAccountRegistrationEnum } from '@/models/account/types';
// images
import Lock from '@/components/ui/new-icons/Lock';
import {
  ForwardArrow,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';

const GuestAccountPromptLogout = ({ currentUser, buttonStyle }) => {
  const dispatch = useDispatch();

  const logoutHandler = () => {
    // If user is logged in, log them out (This case would happen if a user was already logged in
    //  from another session and goes to this landing page but does not have access to the event.)
    if (currentUser && currentUser.accountId) {
      // Logout this account since it does not have access to the event
      dispatch({
        type: 'account/logoutNoRedirect',
      });
    }

    // Set the registration step back to login method
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.LOGIN_METHOD },
    });
    window.location.reload();
  };

  return (
    <>
      <div className={styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <Lock color={'black'}/>
        </div>
      </div>
      <div className={styles.mainHeading}>Hello Guest!</div>
      <div className={styles.heading}>
        <p>You are already signed in as a Guest for another event.</p>
        <p>You must sign out first before you can access this event.</p>
      </div>
      <div className={styles.button}>
        <button
          type="submit"
          onClick={logoutHandler}
          style={buttonStyle}
          className={styles.submitButton}
        >
          {/* Forward Arrow SVG */}
          <ForwardArrow color={buttonStyle.color}/>
          <p className={styles.buttonText}>Sign Out</p>
        </button>
      </div>
    </>
  );
};
export default GuestAccountPromptLogout;
